import { debounce } from 'debounce'
import { withTranslation, Trans } from 'react-i18next'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { AdministratorTable } from '@modules/admin/administrators/Admin.Table'
import FilterBar from '@modules/admin/shared/FiltersBar'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import CustomPagination from '@modules/tableComponents/Pagination'
import InputField from '@modules/formFields/InputField'
import SelectAdminType from '@modules/formFields/SelectAdminTypeField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectProviderField from '@modules/formFields/SelectProviderField'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'

class AdministratorIndex extends Component {
  state = {
    administrators: [],
    page: null,
    pageSize: 50,
    total: 0,
    isFetching: false,
    search: '',
    nameFilter: '',
    emailFilter: '',
    companyFilter: [],
    providerFilter: [],
    typeFilter: undefined,
  }

  administratorsClient = Consultations.administrators

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchAdministrators)
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }

  fetchAdministrators = () => {
    const { page, pageSize } = this.state

    const filters = {
      search: this.state.search,
      name: this.state.nameFilter ? this.state.nameFilter : undefined,
      company_api_keys: this.state.companyFilter ? this.state.companyFilter.map((co) => co.api_key) : undefined,
      provider_ids: this.state.providerFilter ? this.state.providerFilter.map((pr) => pr.id) : undefined,
      type: this.state.typeFilter ? this.state.typeFilter.id : undefined,
      email: this.state.emailFilter ? this.state.emailFilter : undefined,
    }

    this.setState({ isFetching: true })

    return this.administratorsClient
      .index({ page, pageSize, ...filters })
      .then((response) => {
        return this.setState({
          administrators: response.data,
          page: response.meta.current_page,
          lastPage: response.meta.last_page,
          isFetching: false,
          total: response.meta.total,
        })
      })
      .catch((err) => {
        this.setState({ isFetching: false, administrators: [] })
        alert(err.message)
      })
  }

  debouncedFetch = debounce(this.fetchAdministrators, 350, false)

  componentDidMount() {
    this.fetchAdministrators()
  }

  render() {
    const { administrators, isFetching, nameFilter, providerFilter, companyFilter, typeFilter, emailFilter, total } =
      this.state

    const { t } = this.props

    return (
      <div>
        <DashboardHeader title={<Trans>Administradores</Trans>} total={total}>
          <AccessControl requiredPermission="professional.manage">
            <Link to={`administrator/create`} className="btn btn-primary">
              <Trans>Crear</Trans>
            </Link>
          </AccessControl>
        </DashboardHeader>

        <FilterBar onChange={this.onTypeSearch} value={this.state.search}>
          <InputField
            placeholder={t('Nombre')}
            input={{
              value: nameFilter,
              onChange: (e) => this.setState({ nameFilter: e.target.value, page: 1 }),
            }}
          />

          <InputField
            placeholder={t('Email')}
            input={{
              value: emailFilter,
              onChange: (e) => this.setState({ emailFilter: e.target.value, page: 1 }),
            }}
          />
          <SelectCompanyField
            placeholder={t('Compañías')}
            multi
            input={{
              value: companyFilter,
              onChange: (companies) => this.setState({ companyFilter: companies, page: 1 }),
            }}
          />

          <SelectProviderField
            placeholder={t('Proveedores')}
            multi
            input={{
              value: providerFilter,
              onChange: (speciality) => this.setState({ providerFilter: speciality, page: 1 }),
            }}
          />

          <SelectAdminType
            placeholder={t('Tipo Administrador')}
            input={{
              value: typeFilter,
              onChange: (type) => this.setState({ typeFilter: type, page: 1 }),
              onFocus: () => null,
              onBlur: () => null,
            }}
          />
        </FilterBar>

        <Loading isFetching={isFetching} />

        {administrators !== null && <AdministratorTable administrators={administrators} />}

        <CustomPagination
          onClickItem={this.handleChangePage}
          activePage={this.state.page}
          totalPages={this.state.lastPage}
          maxButtons={7}
        />
      </div>
    )
  }
}

export default withTranslation()(AdministratorIndex)
